<div class="all">
  <h1>알림</h1>

  <div class="list_wrapper" *ngIf="isReady">
    <div class="alarm_item" *ngFor="let item of alarms">
      <div class="head">
        <h5>{{ item.title }}</h5>
        <span class="badge" *ngIf="!item.confirmswitch">N</span>
        <span class="date">{{ item.datecreated | date: 'yyyy.MM.dd HH:mm' }}</span>
      </div>

      <p class="text">{{ item.content }}</p>
    </div>

    <div class="no_data" *ngIf="alarms.length == 0">알림 내역이 존재하지 않습니다.</div>
  </div>

  <div class="btn">
    <button class="btn btn-outline-primary" (click)="dismiss()">닫기</button>
  </div>
</div>
